import TranslateIcon from '@mui/icons-material/Translate';
import { ComponentType, SVGProps } from 'react';
import { matchPath } from 'react-router-dom';

import { Icons } from 'shared/assets';
import { routesApp } from 'shared/config';

export type NavIcon = ComponentType<SVGProps<SVGSVGElement>> | typeof TranslateIcon;

export type NavItem = {
  label: string;
  path: string;
  icon: NavIcon;
};

export type NavItemWithActive = NavItem & { isActive: boolean };

export const NAV_ITEMS: NavItem[] = [
  { label: 'Peoples', path: routesApp.peoples, icon: Icons.People },
  { label: 'Pets', path: routesApp.pets, icon: Icons.Pet },
  { label: 'Users', path: routesApp.users, icon: Icons.Users },
  { label: 'Voices', path: routesApp.voices, icon: Icons.Blogers },
  { label: 'Pharma companies', path: routesApp.pharmaCompanies, icon: Icons.PharmaCompanies },
  { label: 'Analytics', path: routesApp.analytics, icon: Icons.Analytics },
  { label: 'Translations', path: routesApp.translations, icon: TranslateIcon },
  { label: 'Support', path: routesApp.supportMessages, icon: Icons.Support },
];

/** Segment-aware prefix match: '/users' is active on '/users' and '/users/42', not on '/users-extra'. */
export const withActive = (items: NavItem[], pathname: string): NavItemWithActive[] =>
  items.map((item) => ({ ...item, isActive: matchPath({ path: `${item.path}/*` }, pathname) !== null }));

/** Accessible name for icon-only controls; includes the unread count for Support. */
export const getNavAriaLabel = (item: NavItem, newMessagesCount: number): string =>
  item.path === routesApp.supportMessages && newMessagesCount > 0
    ? `${item.label}, ${newMessagesCount} new messages`
    : item.label;

/** Breakpoint above which nav items show icon + label; below it, icon-only. Measured, not MUI `lg`. */
export const WIDE_NAV_MIN_WIDTH = 1440;
